import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import AuthorBadge from './AuthorBadge';

// Large featured article card for the News page.
const FeaturedArticle = ({ article }) => (
  <Link to={`/news/${article.id}`} className="dctv-card rounded-2xl overflow-hidden grid lg:grid-cols-2 group">
    <div className="relative h-72 lg:h-auto overflow-hidden">
      <img src={article.image} alt={article.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
    </div>
    <div className="p-9">
      <span className="dctv-eyebrow text-[#e8743b]">Featured · {article.theme}</span>
      <p className="text-[#6b7384] text-xs mt-2">{article.date} · {article.readTime}</p>
      <h2 className="font-serif-dctv text-3xl font-bold text-white mt-3 leading-snug">{article.title}</h2>
      <p className="text-[#9aa3b2] text-[15px] leading-relaxed mt-4">{article.excerpt}</p>
      <div className="mt-6">
        <AuthorBadge author={article.author} size="lg" />
      </div>
      <span className="inline-flex items-center gap-2 mt-6 text-[#e8743b] font-semibold text-sm">Read story <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" /></span>
    </div>
  </Link>
);

export default FeaturedArticle;
